import { z } from "zod";
import { capitalize } from "../../strings";
import { ZodPassword } from "../zod-types/zod-password";

export const userSignUpInviteSchema = z
	.object({
		email: z.email(),
		password: ZodPassword,
		confirmPassword: z.string(),
		firstName: z.string().min(1, "First name is required").transform(capitalize),
		lastName: z.string().min(1, "Last name is required").transform(capitalize),
		otp: z.string().min(8).max(8),
	})
	.superRefine((data, context) => {
		if (data.password !== data.confirmPassword) {
			context.addIssue({
				code: z.ZodIssueCode.custom,
				message: "Passwords do not match",
				path: ["confirmPassword"],
			});
		}
	});

export type UserSignUpInviteSchema = z.infer<typeof userSignUpInviteSchema>;
